import { connect } from 'react-redux'

import { selectAction, openTourAction, openPanelAction, changeShowFiltersAction, collapseSidebarAction } from './actions'
import PopupContentComponent from './PopupContentComponent'

const mapStateToProps = state => {
  return {
    places: state.places,
    selected: state.selected,
    multiselectSelected: state.multiselectSelected,
    isTourOpened: state.isTourOpened,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSelectClick: selected => dispatch(selectAction(selected)),
    openVirtualTour: opened => dispatch(openTourAction(opened)),
    openPanel: open => dispatch(openPanelAction(open)),
    changeShowFilters: show => dispatch(changeShowFiltersAction(show)),
    onCollapseSidebar: collapsed => dispatch(collapseSidebarAction(collapsed)),
  }
}

const PopupContentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PopupContentComponent)

export default PopupContentContainer



// WEBPACK FOOTER //
// ./src/PopupContentContainer.js